/* eslint-disable jsx-a11y/anchor-is-valid */
import "./styles/Notifications.scss";

import React, { Component } from "react";
import Loading from "./Loading";
import moment from "moment";
import Rainbow from "rainbowvis.js";
import Chart from "./Chart";
import ResponsesTable from "./ResponsesTable";
import ResponsesNotTable from "./ResponsesNotTable";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAnswers } from "../api/answers";

class NotificationAnswersSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answers: undefined,
      filterByAnswer: undefined,
      showOthersChart: false,
      showResponses: true,
      showNotYetResponded: true,
      autoRefresh: false,
    };

    this.interval = undefined;
  }

  componentDidMount() {
    this.fetchAnswers();
  }

  componentWillUnmount() {
    if (this.interval) clearInterval(this.interval);
  }

  onToogleAutoRefresh = () => {
    const doAutoRefresh = !this.state.autoRefresh;

    this.setState({
      autoRefresh: doAutoRefresh,
    });

    if (doAutoRefresh) {
      this.interval = setInterval(() => this.fetchAnswers(), 5000);
    } else {
      clearInterval(this.interval);
    }
  };

  fetchAnswers = () => {
    getAnswers(this.props.notification.id)
      .then((res) => {
        this.setState({
          answers: res,
          isLoading: false,
        });
      })
      .catch((err) => {
        // TODO show error
      });
  };

  onSelectResponse = (text) => {
    this.setState({
      filterByAnswer: text,
      showOthersChart: text === "Other Resp.",
    });
  };

  onSelectOtherResponse = (text) => {
    this.setState({
      filterByAnswer: text,
      showOthersChart: true,
    });
  };

  onEditResponse = () => {
    this.fetchAnswers();
  };

  render() {
    const answers = this.state.answers;

    if (!answers) {
      return <Loading />;
    }

    const notification = this.props.notification;

    const isAlreadySent = moment(notification.sentAt).isBefore(moment());

    const isStillAcceptingAnswers = notification.respondUntil
      ? moment(notification.respondUntil).isAfter(moment())
      : true;

    const isExpectResponses =
      notification.allowOpenText ||
      (notification.ExpectedResponses &&
        notification.ExpectedResponses.length > 0);

    const canAutoRefresh =
      isStillAcceptingAnswers && isAlreadySent && isExpectResponses;

    const pendingAnswers = answers.individual.filter(
      (a) => a.text === null
    );
    const receivedAnswers = answers.individual.filter(
      (a) => a.text !== null
    );

    const renderResponses = () => {
      if (receivedAnswers.length === 0) {
        return <p className="is-info">No responses to show.</p>;
      }

      const pieChart = () => {
        const expres = () => {
          var rainbow = new Rainbow();
          rainbow.setNumberRange(0, Math.max(answers.aggregated.length - 1, 1));
          rainbow.setSpectrum("#000028", "#009999");
          return answers.aggregated.map((r, ix) => ({
            title: r.text,
            value: r.count,
            color: "#" + rainbow.colorAt(ix),
          }));
        };

        const otherresp = () => {
          const excludeWords = ["AND", "OU", "E", "OR"];

          notification.ExpectedResponses.forEach((r) =>
            excludeWords.push(r.text)
          );

          const options = {};

          receivedAnswers.forEach((r) => {
            r.text.split(/[ ,]+/).forEach((w) => {
              if (!excludeWords.includes(w)) {
                if (options[w]) {
                  options[w] += 1;
                } else {
                  options[w] = 1;
                }
              }
            });
          });

          var rainbow = new Rainbow();
          rainbow.setNumberRange(
            0,
            Math.max(Object.keys(options).length - 1, 1)
          );
          rainbow.setSpectrum("#000028", "#009999");

          return Object.keys(options).map((k, ix) => ({
            title: k,
            value: options[k],
            color: "#" + rainbow.colorAt(ix),
          }));
        };

        return (
          <div className="mt-2">
            <p className="has-color-primary">
              Received {receivedAnswers.length} responses of{" "}
              {answers.individual.length} notifications sent (
              {(
                (receivedAnswers.length / answers.individual.length) *
                100
              ).toFixed(2)}
              )%.
            </p>

            <div className="columns mt-3 is-centered">
              <div className={`column ${this.state.showOthersChart ? 'is-6' : 'is-full' } is-flex  is-justify-content-center is-align-items-center chart-container has-text-centered`}>
                <div>
                  <p className="mb-2">Expected Responses</p>
                  <Chart data={expres()} onSelect={this.onSelectResponse} />
                </div>
              </div>
              {this.state.showOthersChart && (
                <>
                  <div className="column is-6 is-flex is-centered is-justify-content-center is-align-items-center chart-container has-text-centered">
                    <div>
                      <p className="mb-2">Other Responses</p>
                      <Chart
                        data={otherresp()}
                        onSelect={this.onSelectOtherResponse}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>

              
            <div className="has-text-centered mb-3">
                {this.state.filterByAnswer ? 
                  <p >Displaying response: <span className='has-text-primary'>{this.state.filterByAnswer}</span></p>
                  :
                  <>Displaying all responses.</>
                }


            </div>
          </div>
        );
      };

      const responsesTable = () => {      
        return (
          <ResponsesTable
            responses={receivedAnswers}
            filterByAnswer={this.state.filterByAnswer}
            onEditResponse={this.onEditResponse}
            expected={notification.ExpectedResponses.map((er) => er.text)}
          />
        );
      };

      return (
        <>
          {pieChart()}
          {responsesTable()}
        </>
      );
    };

    const renderNotYetResponded = () => {
      return (
        <>
          <ResponsesNotTable showRecipients={pendingAnswers} />
        </>
      );
    };

    return (
      <div className="section pt-2">
        {canAutoRefresh && (
          <div className="field" onClick={this.onToogleAutoRefresh}>
            <input
              type="checkbox"
              className="switch is-small"
              checked={this.state.autoRefresh}
              onChange={() => {}}
            />
            <label>Auto refresh responses</label>
          </div>
        )}

        <div className="container">
          <div className="card is-fullwidth mb-4">
            <header
              className="card-header"
              onClick={() =>
                this.setState({ showResponses: !this.state.showResponses })
              }
            >
              <p className="card-header-title">Responses</p>
              <a className="card-header-icon card-toggle">
                <FontAwesomeIcon icon="angle-down"></FontAwesomeIcon>
              </a>
            </header>
            <div
              className={`card-content ${
                this.state.showResponses ? "" : "is-hidden"
              }`}
            >
              <div className="content">{renderResponses()}</div>
            </div>
          </div>

          <div className="card is-fullwidth mt-4">
            <header
              className="card-header"
              onClick={() =>
                this.setState({
                  showNotYetResponded: !this.state.showNotYetResponded,
                })
              }
            >
              <p className="card-header-title">Not yet responded</p>
              <a className="card-header-icon card-toggle">
                <FontAwesomeIcon icon="angle-down"></FontAwesomeIcon>
              </a>
            </header>
            <div
              className={`card-content ${
                this.state.showNotYetResponded ? "" : "is-hidden"
              }`}
            >
              <div className="content">{renderNotYetResponded()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(NotificationAnswersSection);
